import React from 'react';

const DeleteFusions = ({
  modalInfo,
  handleCloseModal,
  handleDeleteFusions
}) => {
  return (
    <div className="delete-modal-content">
      <p>Delete the selected Fusions?</p>
      <div className="delete-modal-buttons">
        <button
          className="btn btn--secondary-outline delete-modal-button"
          onClick={() => handleDeleteFusions(modalInfo)}
        >
          Delete
        </button>
        <button
          className="btn btn--primary-outline delete-modal-button"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteFusions;
